import { render } from "./Reportage.vue?vue&type=template&id=066dfc6a&scoped=true"
import script from "./Reportage.vue?vue&type=script&lang=js"
export * from "./Reportage.vue?vue&type=script&lang=js"

import "./Reportage.vue?vue&type=style&index=0&id=066dfc6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-066dfc6a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "066dfc6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('066dfc6a', script)) {
    api.reload('066dfc6a', script)
  }
  
  module.hot.accept("./Reportage.vue?vue&type=template&id=066dfc6a&scoped=true", () => {
    api.rerender('066dfc6a', render)
  })

}

script.__file = "src/components/Reportage.vue"

export default script